import { Currency } from './currency'
import { LocationType } from './roomtype'

type Multilingual = {
  label: string
  nativeLabel: string
  value: string
}

export type AddOnType =
  | 'AddBed'
  // | 'Child1'
  // | 'Child2'
  // | 'Child3'
  // | 'Child4'
  | 'Cot'
  | 'Breakfast'
  | 'Custom'
  | ''

export type AddOn = {
  type: AddOnType
  name: string
  nameTranslatedList: Multilingual[]
  code: string
  applyMultiplier?: Boolean
  perPerson?: Boolean
  perRoomNight?: Boolean
  amount?: number
  currency?: string
  notDisabled?: Boolean
}

export type RatePlanBasicDetailsForGet = {
  type: LocationType
  roomTypeCode: string
  displayRoomTypeCode?: string
  parentRatePlanCode?: string
  name: string
  nameTranslatedList: Multilingual[]
  ratePlanCode: string
  code: string
  displayRatePlanCode?: string
  boardType: string
  ratePolicy: string
  ratePolicyTranslatedList: Multilingual[]
  ratePlanID: string
  roomTypeID: string
  accommodationId: string
  providerCode: string
  displayProviderCode?: string
  active: boolean
  deleted: boolean
  roomTypeName: string
  roomTypeNameTranslatedList: Multilingual[]
}

export type RatePlanBasicDetailsForGenerate = {
  type: LocationType
  roomTypeCode: string
  parentRatePlanCode?: string
  name: string
  nameTranslatedList: Multilingual[]
  code: string[]
  boardType: string
  ratePolicy: string
  ratePolicyTranslatedList: Multilingual[]
  providerCode: string
}

export type RatePlanBasicDetailsForModify = {
  type: LocationType
  parentRatePlanCode?: string
  roomTypeCode: string
  name: string
  nameTranslatedList: Multilingual[]
  code: string
  boardType: string
  ratePolicy: string
  ratePolicyTranslatedList: Multilingual[]
  ratePlanID?: string
  roomTypeName?: string
  roomTypeNameTranslatedList?: Multilingual[]
  roomTypeID?: string
  accommodationId?: string
  parentRoomTypeCode?: string
  providerCode: string
}

export type SupportedWalletType = {
  currency: Currency
  walletTypes: string[]
  isSelected?: boolean
}

/**
 * matchSorter key array for searching RatePlanBrief objects. `code` does NOT
 * exist on these objects (the old key arrays searched it and silently matched
 * nothing); `ratePlanCode`/`roomTypeCode` are internal codes while the UI
 * renders the `display*` aliases, so both must be searchable.
 *
 * The `satisfies readonly (keyof RatePlanBrief)[]` guard makes renames on the
 * type a COMPILE error here (matchSorter would otherwise skip a dead key
 * silently); the runtime contract lives in ratePlanSearch.test.ts.
 */
export const RATE_PLAN_SEARCH_KEYS = [
  'name',
  'ratePlanCode',
  'displayRatePlanCode',
  'roomTypeName',
  'roomTypeCode',
  'displayRoomTypeCode'
] as const satisfies readonly (keyof RatePlanBrief)[]

export type RatePlanBrief = {
  id: string
  name: string
  ratePlanCode: string
  displayRatePlanCode?: string
  type: LocationType
  roomTypeCode: string
  displayRoomTypeCode?: string
  roomTypeName: string
  roomTypeID: string
  accommodationID: string
  numberOfRates: number
  boardType: string
  deleted: boolean
  active: boolean
  parentRatePlanCode?: string
  parentRoomTypeCode?: string
  providerID?: string
  providerName: string
  providerCode: string
}

export type RatePlanForGet = {
  basicDetails: RatePlanBasicDetailsForGet
  supportedWalletTypes: SupportedWalletType[]
}

export type RatePlanForGenerate = {
  basicDetails: RatePlanBasicDetailsForGenerate
  supportedWalletTypes: SupportedWalletType[]
}

export type RatePlanForModify = {
  basicDetails: RatePlanBasicDetailsForModify
  supportedWalletTypes: SupportedWalletType[]
}

export type JobStatusForRateplan = {
  rateplanName: string
  status: string
  code: string
}

export type BooleanAddOns = {
  type: boolean
  name: boolean
  nameTranslatedList: boolean
  code: boolean
  applyMultiplier: boolean
  perPerson: boolean
  perRoomNight: boolean
}
